import { Component, ViewChild,OnInit} from '@angular/core';
import { DxFormComponent } from 'devextreme-angular';
import { HttpClient } from '@angular/common/http'; 
import { Configuration } from '../../../app.constants';
import {RegistrationService,Registration,Gender}from  './../../services/registration.service';
import {formatDate} from '@angular/common';
import {HelperService} from '../../../shared/services/helper.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';
import { AuthService, AppInfoService, PortalStudentLogIn } from '../../../shared/services';
import { AppConfigService } from '../../../app-config.service';


@Component({
  selector: 'studentverifywithprn',
  templateUrl: './studentverifywithprn.component.html',
  styleUrls: ['./studentverifywithprn.component.scss']
})
export class StudentverifywithprnComponent implements OnInit {
  @ViewChild(DxFormComponent) myform:DxFormComponent;
  password = "";
  public headerLabel :string ="Registration"; 
RegistrationData:Registration;
isValid:boolean;
isVisible: boolean = true; 
isdisable:boolean=true;
dataSource:any; 
LanguageLabel:any; 
popupVisible = false;
errorMessage: string[] = new Array(); 
public logoPath :string="";  
VerifyBtnDisabled:boolean=true;
StudentExists:string="";
UniverSityPRNNO:string="";

constructor(private http:HttpClient,
  private router: Router,private route: ActivatedRoute,
  private RegistrationService:RegistrationService, 
  private authService: AuthService, 
  private configuration: Configuration,
  private helperService:HelperService,private Location:Location,
  private appConfigService : AppConfigService ){  
    this.logoPath = this.appConfigService.LogoPath;
 }
  ngOnInit() {
    this.LanguageLabel =this.configuration.LanguageLabel[0];
    //this.isStyle="{'style': 'text-transform: uppercase'}";
   if(!this.configuration.RegistrationConfirm){
      this.router.navigate(['/checklist-registrationwithprn-info']); 

    }
    this.cleardata();
    this.errorMessage=[] 
  }
  redirectToLogin(){
    this.router.navigate(['/login-form']);  
  }
  findRecord(){debugger
    if ((this.RegistrationData.UniverSityPRNNO=="") || (this.RegistrationData.UniverSityPRNNO==null))
    {
      this.helperService.showWarningMessage("PRN No. Required");   
      return false;
    }
    this.UniverSityPRNNO = this.RegistrationData.UniverSityPRNNO;
    this.RegistrationService.GetStudentByUniverSityPRNNO(this.RegistrationData.UniverSityPRNNO)
    .subscribe((data:Registration[]) => this.dataSource = data,
    error => {
    alert(error);
    },
    () => {debugger 
      //console.log(this.RegistrationData);   
      if(this.dataSource.length>0){ 
      this.RegistrationData = this.dataSource[0];
      //this.RegistrationData.UniverSityPRNNO =""+ this.dataSource[0].UniverSityPRNNO + "";
      this.RegistrationData.UniverSityPRNNO =""+ this.UniverSityPRNNO + "";
        if( this.dataSource[0].StudentExists == 1){
          this.VerifyBtnDisabled = true;
          this.StudentExists="You are alreadly registred and your Login Id is " + ""+ this.dataSource[0].StudentLoginId + "";
          
          this.helperService.showWarningMessage(this.StudentExists);
        }
        else{
          this.VerifyBtnDisabled = false;
          this.StudentExists="";
        }
      }else{
        this.helperService.showWarningMessage("Student Name Not Found, Please try another PRN");
      }
    }); 
  }
  postpage(){
    
    if ((this.RegistrationData.StudentTitle=="") || (this.RegistrationData.StudentTitle==null))
    {
      this.helperService.showWarningMessage("Student Name Required");   
      return false;
    }

    this.popupVisible = true;

  }
  confirmOK() {
    this.configuration.RegistrationConfirm=true;
    //this.popupVisible=true;
    let navigationExtras: NavigationExtras = {
     queryParams: { "OldStudent" : "N", "UniverSityPRNNO" : this.RegistrationData.UniverSityPRNNO }
     }
     this.router.navigate(['/registrationForm'],navigationExtras);
  }
  onCloseButton(){
    this.StudentExists="";
    this.popupVisible = false; 
    this.VerifyBtnDisabled = false;
    this.cleardata();
  }

  cleardata(){
    this.StudentExists="";
    this.RegistrationData={
    StudentTitle:null,
    StuPoartlaID: null,
    StudeMailId: null,
    FirstName:null,
    LastName: null,
    MiddleName: "",
    StuGender: null,
    MobileNo: null,
    EmailID:null,
    StudentMothersName: "",
    StudentBirtHDate:null,
    Password: null,
    CollegeID:null,
    StudentID:null,
    MoblieOTP: null,
    EmailOTP: null,
    Question1A:null,
    Question2A: null,
    Question3A: null,
    Question4A: null,
    Question5A: null,
    confirmPassword:null,
    PreExamOtpId:null,
    StudentRegType:null,
    PRNNO:null,
    UniverSityPRNNO:null,
    StudentName:null,
    ExternalFlag:null,
    }
    }

}
